import { profileFailed, profileSuccess, setProfile } from "./reducer"
import { RootState } from "slices";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import { User, doUpdateUser } from "../../../services/user.service";

export const editProfile = (
  user: User
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
  try {
    let response: any;

    response = await doUpdateUser(user as unknown as Record<string, unknown>);

    if (response) {
      dispatch(profileSuccess(response))
    }

  } catch (error) {
    dispatch(profileFailed(error))
  }
}

export const onGetProfile = (): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
  try {
    const response: any = JSON.parse(localStorage.getItem('authUser') as string);
    dispatch(setProfile(response))
  } catch (error) {
    dispatch(profileFailed(error))
  }
}